module.exports = __webpack_public_path__ + "media/application/images/icons/sidebar-step-e6fddb5229f86314bbc2d75af3f6f640.svg";